"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("./catchError");
const _backblaze = /*#__PURE__*/ _interop_require_default(require("~/plugins/backblaze"));
const _discord = /*#__PURE__*/ _interop_require_default(require("~/plugins/discord"));
const _gcs = /*#__PURE__*/ _interop_require_default(require("~/plugins/gcs"));
const _linode = /*#__PURE__*/ _interop_require_default(require("~/plugins/linode"));
const _mattermost = /*#__PURE__*/ _interop_require_default(require("~/plugins/mattermost"));
const _minio = /*#__PURE__*/ _interop_require_default(require("~/plugins/minio"));
const _ovhCloud = /*#__PURE__*/ _interop_require_default(require("~/plugins/ovhCloud"));
const _s3 = /*#__PURE__*/ _interop_require_default(require("~/plugins/s3"));
const _scaleway = /*#__PURE__*/ _interop_require_default(require("~/plugins/scaleway"));
const _slack = /*#__PURE__*/ _interop_require_default(require("~/plugins/slack"));
const _smtp = /*#__PURE__*/ _interop_require_default(require("~/plugins/smtp"));
const _mailerSend = /*#__PURE__*/ _interop_require_default(require("~/plugins/mailerSend"));
const _spaces = /*#__PURE__*/ _interop_require_default(require("~/plugins/spaces"));
const _teams = /*#__PURE__*/ _interop_require_default(require("~/plugins/teams"));
const _twilio = /*#__PURE__*/ _interop_require_default(require("~/plugins/twilio"));
const _twilioWhatsapp = /*#__PURE__*/ _interop_require_default(require("~/plugins/twilioWhatsapp"));
const _upcloud = /*#__PURE__*/ _interop_require_default(require("~/plugins/upcloud"));
const _vultr = /*#__PURE__*/ _interop_require_default(require("~/plugins/vultr"));
const _ses = /*#__PURE__*/ _interop_require_default(require("~/plugins/ses"));
const _r2 = /*#__PURE__*/ _interop_require_default(require("~/plugins/r2"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _Local = /*#__PURE__*/ _interop_require_default(require("~/plugins/storage/Local"));
const _globals = require("~/utils/globals");
const _Plugin = /*#__PURE__*/ _interop_require_default(require("~/models/Plugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const defaultPlugins = [
    _slack.default,
    _teams.default,
    _discord.default,
    _twilioWhatsapp.default,
    _twilio.default,
    _s3.default,
    _minio.default,
    _gcs.default,
    _mattermost.default,
    _spaces.default,
    _backblaze.default,
    _vultr.default,
    _ovhCloud.default,
    _linode.default,
    _upcloud.default,
    _smtp.default,
    _mailerSend.default,
    _scaleway.default,
    _ses.default,
    _r2.default
];
let NcPluginMgrv2 = class NcPluginMgrv2 {
    /* active plugins */ // constructor(app: Noco, ncMeta: NcMetaIO) {
    //   this.app = app;
    //   this.ncMeta = ncMeta;
    //   this.activePlugins = [];
    // }
    static async init(ncMeta = _Noco.default.ncMeta) {
        // extract duplicate plugin ids from default plugins and throw error
        const duplicateIds = defaultPlugins.map((p)=>p.id).filter((id, index, self)=>self.indexOf(id) !== index);
        if (duplicateIds.length) {
            throw new Error(`Duplicate plugin ids found in default plugins: ${duplicateIds.join(', ')}`);
        }
        /* Populate rows into nc_plugins table if not present */ for (const plugin of defaultPlugins){
            const pluginConfig = await ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, plugin.id);
            if (!pluginConfig) {
                await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, {
                    id: plugin.id,
                    title: plugin.title,
                    version: plugin.version,
                    logo: plugin.logo,
                    icon: plugin.icon,
                    description: plugin.description,
                    tags: plugin.tags,
                    category: plugin.category,
                    input_schema: JSON.stringify(plugin.inputs)
                });
            } else if (pluginConfig.version !== plugin.version) {
                await ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, {
                    title: plugin.title,
                    version: plugin.version,
                    logo: plugin.logo,
                    icon: plugin.icon,
                    description: plugin.description,
                    tags: plugin.tags,
                    category: plugin.category,
                    input_schema: JSON.stringify(plugin.inputs)
                }, pluginConfig.id);
            }
        }
        await this.initPluginsFromEnv();
    }
    static async initPluginsFromEnv() {
        /*
     * NC_S3_BUCKET_NAME
     * NC_S3_REGION
     * NC_S3_ENDPOINT
     * NC_S3_ACCESS_KEY
     * NC_S3_ACCESS_SECRET
     * */ if (process.env.NC_S3_BUCKET_NAME && (process.env.NC_S3_REGION || process.env.NC_S3_ENDPOINT)) {
            const s3Plugin = await _Plugin.default.getPlugin(_s3.default.id);
            const s3CfgData = {
                bucket: process.env.NC_S3_BUCKET_NAME,
                region: process.env.NC_S3_REGION,
                endpoint: process.env.NC_S3_ENDPOINT,
                force_path_style: process.env.NC_S3_FORCE_PATH_STYLE === 'true',
                acl: process.env.NC_S3_ACL
            };
            if (process.env.NC_S3_ACCESS_KEY && process.env.NC_S3_ACCESS_SECRET) {
                s3CfgData.access_key = process.env.NC_S3_ACCESS_KEY;
                s3CfgData.access_secret = process.env.NC_S3_ACCESS_SECRET;
            }
            await _Plugin.default.update(s3Plugin.id, {
                active: true,
                input: JSON.stringify(s3CfgData)
            });
        }
        if (process.env.NC_SMTP_FROM && process.env.NC_SMTP_HOST && process.env.NC_SMTP_PORT) {
            const smtpPlugin = await _Plugin.default.getPlugin(_smtp.default.id);
            await _Plugin.default.update(smtpPlugin.id, {
                active: true,
                input: JSON.stringify({
                    from: process.env.NC_SMTP_FROM,
                    host: process.env.NC_SMTP_HOST,
                    port: process.env.NC_SMTP_PORT,
                    username: process.env.NC_SMTP_USERNAME,
                    password: process.env.NC_SMTP_PASSWORD,
                    secure: process.env.NC_SMTP_SECURE === 'true',
                    ignoreTLS: process.env.NC_SMTP_IGNORE_TLS === 'true',
                    rejectUnauthorized: process.env.NC_SMTP_REJECT_UNAUTHORIZED === 'true'
                })
            });
        }
    }
    static async storageAdapter(ncMeta = _Noco.default.ncMeta) {
        const pluginData = await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, {
            category: _nocodbsdk.PluginCategory.STORAGE,
            active: true
        });
        if (!pluginData) return new _Local.default();
        const pluginConfig = defaultPlugins.find((c)=>c.title === pluginData.title && c.category === _nocodbsdk.PluginCategory.STORAGE);
        const plugin = new pluginConfig.builder(ncMeta, pluginData);
        if (pluginData == null ? void 0 : pluginData.input) {
            pluginData.input = JSON.parse(pluginData.input);
        }
        await plugin.init(pluginData == null ? void 0 : pluginData.input);
        return plugin.getAdapter();
    }
    static async emailAdapter(isUserInvite = true, ncMeta = _Noco.default.ncMeta) {
        const pluginData = await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, {
            category: _nocodbsdk.PluginCategory.EMAIL,
            active: true
        });
        if (!pluginData) {
            // return null to show the invite link in UI
            if (isUserInvite) return null;
            // for webhooks, throw the error
            throw new Error('Plugin not configured / active');
        }
        const pluginConfig = defaultPlugins.find((c)=>c.title === pluginData.title && c.category === _nocodbsdk.PluginCategory.EMAIL);
        const plugin = new pluginConfig.builder(ncMeta, pluginData);
        if (pluginData == null ? void 0 : pluginData.input) {
            pluginData.input = JSON.parse(pluginData.input);
        }
        await plugin.init(pluginData == null ? void 0 : pluginData.input);
        return plugin.getAdapter();
    }
    static async webhookNotificationAdapters(title, ncMeta = _Noco.default.ncMeta) {
        const pluginData = await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, {
            title,
            active: true
        });
        if (!pluginData) throw new Error('Plugin not configured / active');
        const pluginConfig = defaultPlugins.find((c)=>c.title === pluginData.title);
        const plugin = new pluginConfig.builder(ncMeta, pluginData);
        if (pluginData == null ? void 0 : pluginData.input) {
            pluginData.input = JSON.parse(pluginData.input);
        }
        await plugin.init(pluginData == null ? void 0 : pluginData.input);
        return plugin.getAdapter();
    // return this.activePlugins?.reduce((obj, plugin) => {
    //   if (plugin instanceof XcWebhookNotificationPlugin) {
    //     obj[
    //       plugin?.config?.title
    //     ] = (plugin as XcWebhookNotificationPlugin)?.getAdapter();
    //   }
    //   return obj;
    // }, {});
    }
    static async test(args) {
        args.input = typeof (args == null ? void 0 : args.input) === 'string' ? JSON.parse(args == null ? void 0 : args.input) : args == null ? void 0 : args.input;
        switch(args.category){
            case 'Storage':
                {
                    var _tempPlugin_getAdapter, _tempPlugin_getAdapter_test, _tempPlugin_getAdapter1;
                    const plugin = defaultPlugins.find((pluginConfig)=>(pluginConfig == null ? void 0 : pluginConfig.title) === args.title);
                    const tempPlugin = new plugin.builder(_Noco.default.ncMeta, plugin);
                    await tempPlugin.init(args == null ? void 0 : args.input);
                    if (!(tempPlugin == null ? void 0 : (_tempPlugin_getAdapter = tempPlugin.getAdapter()) == null ? void 0 : _tempPlugin_getAdapter.test)) _catchError.NcError.notImplemented('Plugin Test');
                    return tempPlugin == null ? void 0 : (_tempPlugin_getAdapter1 = tempPlugin.getAdapter()) == null ? void 0 : (_tempPlugin_getAdapter_test = _tempPlugin_getAdapter1.test) == null ? void 0 : _tempPlugin_getAdapter_test.call(_tempPlugin_getAdapter1);
                }
                break;
            case 'Email':
                {
                    var _tempPlugin_getAdapter2, _tempPlugin_getAdapter_test1, _tempPlugin_getAdapter3;
                    const plugin = defaultPlugins.find((pluginConfig)=>(pluginConfig == null ? void 0 : pluginConfig.title) === args.title);
                    const tempPlugin = new plugin.builder(_Noco.default.ncMeta, plugin);
                    await tempPlugin.init(args == null ? void 0 : args.input);
                    if (!(tempPlugin == null ? void 0 : (_tempPlugin_getAdapter2 = tempPlugin.getAdapter()) == null ? void 0 : _tempPlugin_getAdapter2.test)) _catchError.NcError.notImplemented('Plugin Test');
                    return tempPlugin == null ? void 0 : (_tempPlugin_getAdapter3 = tempPlugin.getAdapter()) == null ? void 0 : (_tempPlugin_getAdapter_test1 = _tempPlugin_getAdapter3.test) == null ? void 0 : _tempPlugin_getAdapter_test1.call(_tempPlugin_getAdapter3);
                }
                break;
            default:
                {
                    var _tempPlugin_getAdapter4, _tempPlugin_getAdapter_test2, _tempPlugin_getAdapter5;
                    const plugin = defaultPlugins.find((pluginConfig)=>(pluginConfig == null ? void 0 : pluginConfig.title) === args.title);
                    const tempPlugin = new plugin.builder(_Noco.default.ncMeta, plugin);
                    await tempPlugin.init(args == null ? void 0 : args.input);
                    if (!(tempPlugin == null ? void 0 : (_tempPlugin_getAdapter4 = tempPlugin.getAdapter()) == null ? void 0 : _tempPlugin_getAdapter4.test)) _catchError.NcError.notImplemented('Plugin Test');
                    return tempPlugin == null ? void 0 : (_tempPlugin_getAdapter5 = tempPlugin.getAdapter()) == null ? void 0 : (_tempPlugin_getAdapter_test2 = _tempPlugin_getAdapter5.test) == null ? void 0 : _tempPlugin_getAdapter_test2.call(_tempPlugin_getAdapter5);
                }
        }
    }
};
const _default = NcPluginMgrv2;
